export default "__VITE_ASSET__cVFmOvVG__"